export enum Auth {
  SERVICE_USER = 'SERVICE_USER',
  CLIENT_SECRET = 'CLIENT_SECRET',
}
